import { layoutEffectsSymbol } from './symbols';
import { createEffect } from './create-effect';
function setLayoutEffects(state, cb) {
    state[layoutEffectsSymbol].push(cb);
}
const useLayoutEffect = createEffect(setLayoutEffects);
export { useLayoutEffect };
